import TermsConditionContent from "./terms_condition.mdx";
export default function TermsCondition() {
  return (
    <div>
      <TermsConditionContent />
    </div>
  );
}
